export default function CTA() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20flow%2C%20golden%20amber%20and%20soft%20cream%20waves%2C%20minimalist%20elegant%20composition%2C%20smooth%20flowing%20lines%2C%20luxurious%20texture%2C%20professional%20corporate%20aesthetic%2C%20warm%20inviting%20atmosphere&width=1600&height=600&seq=mrds-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 to-background-950/70"></div>
      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开启 mrds 之旅了吗？
        </h2>
        <p className="text-background-50/70 text-base md:text-lg max-w-[560px] mx-auto mb-8 leading-relaxed">
          立即注册 mrds，免费体验全部核心功能，感受专业平台带来的效率革命
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            免费开始使用
          </Link>
          <a
            href="/categories"
            className="px-8 py-3 bg-background-50/10 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium text-sm rounded-lg hover:bg-background-50/20 transition-all whitespace-nowrap cursor-pointer"
          >
            查看文档
          </a>
        </div>
      </div>
    </section>
  );
}